<template>
  <div class="Figure-mold-linkage">
    <div class="loading" v-if="percentage<100">
      <div class="content">
        <p>{{percentage}}%</p>
        <p>{{loadText}}</p>
        <el-progress :percentage="percentage" :show-text="false"></el-progress>
      </div>
    </div>
    <iframe
      id="iframemoldLink"
      ref="iframemoldLink"
      frameborder="0"
      width="100%"
      height="100%" 
      @load="moldLinkLoading"
      :src="bimUrl">
    </iframe>
    <!-- <div ref="iframemoldLink" class="figure-model"></div> -->
  </div>
</template>

<script>
export default {
  name: "FigureMoldLinkage",
  components: {},
  data() {
    return {
      percentage:0,
      loadText: '加载渲染配置...',
      // 图模联动
      bimUrl: '',
      flag: true,
      hasClick: false,
      iframemoldLink:{},
      viewPoint: {}
    };
  }, 
  props: {
    
	},
  mounted() {
    let _this = this;
    window.onresize = () => {
      this.mainMenuNone()
    }
    this.viewPoint = this.$project.projectData.viewPointInfo;
    _this.bimUrl = `${this.$project.projectData.platform.figureMoldLinkageSrc}`
    //  this.bimUrl = `${window.pubilc_config.publicModelConfigUrl}projectId=8519e0be-03b3-4d9a-b3da-50c9a2f28a84&model=b495af39-6fc7-4e73-b0f4-bfaf924a512d&ver=`;  
    /*
    let _modelId = window.pubilc_config.figureMoldLinkageModelId;
    let _projectId = window.pubilc_config.figureMoldLinkageProjectId;
    let model = null 
    let obj = {
        modelID: _modelId,//模型id
        projectID: _projectId,//项目id
        versionNO: '',//版本 ""为最新版本
        viewID: '',//指定视图id，""为默认视图  model-more
        DOM: document.querySelector('.figure-model')//渲染容器（请提前确定容器含有宽高）
    }

    model = window.model = new window.bim365.BIMModel(obj)
    model.load()
    //model.load 之后实例化BIM365API 请在load后获取BIM365API
    this.iframemoldLink = window
    model.BIM365API.Events.finishRender.on('default',()=>{//监听模型加载完成事件
        // console.log('模型加载完成')
        _this.percentage = 33;

        // document.querySelector('.example-model-load').remove();
        document.getElementById('viewCube').innerHTML = '';
        setTimeout(()=>{
          _this.hasClick = _this.getiframeMainMenu(_this.iframemoldLink)
          _this.percentage = 50;
        },100)
    })
    */
  },
  methods: {
    moldLinkLoading(){
      let _this = this;
      _this.percentage = 10;
      setTimeout(()=>{
        let iframemoldLink = _this.$refs.iframemoldLink.contentWindow; 
        // _this.iframemoldLink = iframemoldLink;
        let IDmoldLink = document.getElementById('iframemoldLink').contentWindow; 
        _this.percentage = 33;
        
        _this.mainMenuNone()
        iframemoldLink.model.BIM365API.Events.finishRender.on('default',()=>{ 
          setTimeout(()=>{
            _this.hasClick = _this.getiframeMainMenu(IDmoldLink)
            _this.percentage = 50; 
          },100)

        })
      },100)
    },
    mainMenuNone(){//隐藏底部导航条
      let iframemoldLink = this.$refs.iframemoldLink.contentWindow; 
      let mainMenu = iframemoldLink.document.getElementById("app").children[0].children;  //获取要隐藏的div父级对象
      if(typeof mainMenu != 'object'){
        return
      }else{
        let time = setInterval(()=>{  //设置定时循环判断是否获取到id
          if(mainMenu[0].id == 'mainMenu'||mainMenu[0].className == 'wrapper'){
            mainMenu[0].style.display = 'none'
            clearInterval(time)
          }else{
            return
          }
        },100)
      }
    },
    getiframeMainMenu(IDmoldLink) { 
      IDmoldLink.document.querySelector('#mainMenu').querySelector('ul').children[4].click();
      return true
    },

    getVector2dFun(){ 
      let _this = this;
      let iframemoldLink = this.$refs.iframemoldLink.contentWindow
      let modelList =  iframemoldLink.model.BIM365API.Extension.Vector2D.getVector2dData();
        
      _this.percentage = 88;
      let _viewID = modelList[0].viewID;
      if(_viewID){
        let IDmoldLink = document.getElementById('iframemoldLink').contentWindow; 
        if(IDmoldLink.document.querySelector('.viewpoint-center-wp')){
          _this.percentage = 100;
          iframemoldLink.CRMSheetClick(_viewID)
          iframemoldLink.model.BIM365API.Context.setViewPointBasicInfo(this.viewPoint);
        }else{
          setTimeout(()=>{
            _this.percentage = 100;
            iframemoldLink.CRMSheetClick(_viewID) 
            iframemoldLink.model.BIM365API.Context.setViewPointBasicInfo(this.viewPoint);    
          },10000)
        } 
      }else{
        _this.percentage = 100;
      }
    }
  },
  watch: {
    hasClick(n) { 
      if (n) {
        this.getVector2dFun();
      }
    },
    percentage(val){
      if(val == 1){
          this.loadText = '加载材质信息...'
      }else if(val >1 && val <= 5){
          this.loadText = '加载初始化视图...'
      }else if(val >5 && val <= 50){
          this.loadText = '加载当前视图下构件信息...'
      }else if(val >50 && val <= 80){
          this.loadText = '加载几何体信息...'
      }else if(val > 80 && val <= 95){
          this.loadText = '加载视点...'
      }else{
          this.loadText = '构建场景并渲染...'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.Figure-mold-linkage{
  width: 100%;
  height: 100%;
}
.loading{
  position: relative;
  width:100%;
  height: 100%;
  background: #fff;
  text-align: center;
  z-index: 99; 
  .content{
    position: absolute;
    top: 80%;
    left: 50%;
    margin-left: -150px;
    width: 200px;
    height: 100px;
    color: #1890ff;
    border-radius: 4px;
    p{
      margin: 15px 0 ;
      font-size: 16px;
    }
    /deep/ .el-progress-bar__outer{
      height: 10px !important;
    }
    /deep/ .el-progress-bar__inner{
      background: #1890ff;
    }
  }
}
.figure-model{
  width: 100%;
  height: 100%;
  background: #b3c1cd;
}
</style>